import React, { Component } from "react";

import { Form, Button, Input, Row, Col, Spin, Modal, Select, Checkbox, Upload, DatePicker } from "antd";
import config from "../config";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import CompanyStore from "../store/CompanyStore";
import { UploadOutlined } from "@ant-design/icons";
import TicketStore from "../store/TicketStore";
import VehicleStore from "../store/VehicleStore";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import axios from "axios";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
const { Option } = Select;
class TicketAdd extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            show: false,
            ticketId: -1,
            companyId: "",
            loadingSpin: false,
            disabledSaveButton: false,
            waslRegistration: false,
            showVehicleDropdown: false,
            loadData: 1,
            priorityValue: null,
            ticketStatus: 1,
            invoice: '',
            hideFields: true,
            existingIssueRequiredFields: true,
            disabledFields: false,
            installationTypeDropdown: false,
            capacityField: false,
            disabledSequenceNo: false,
            disabledPlateType: false,
            disableWaslRegistration: false
        };

        this.ticketStore = new TicketStore(this)
        this.companyStore = new CompanyStore(this);
        this.vehicleStore = new VehicleStore(this)
        // this.workingHoursStore = new VehicleWorkingHoursStore(this)
        this.cookies = new Cookies();

    }

    async componentDidMount() {
        let tokendata = this.cookies.get("data")
            ? JSON.parse(base64_decode(this.cookies.get("data")))
            : "";
        const userToken = tokendata.userToken;

        this.setState({ token: userToken });
        if (Number(this.props.getUserData().isadmin) !== -1 || Number(this.props.getUserData().isadmin) !== 3) {
            await this.ticketStore.getVehiclesCompanyId(this.props.getUserData().userCompanyId)
            // await this.workingHoursStore.getVehicleGroup({
            //     companyId: this.props.getUserData().userCompanyId,
            //     userId: this.props.getUserData().userId,
            //     isadmin: this.props.getUserData().isadmin,
            // });

            this.setState({ loadData: 1 })
        }
        const Id = this.props.ticketId;

        if (Id) {
            await this.setState({ loadingSpin: true });
            const getTicketData = await this.ticketStore.getTicketDetails({ ticketId: Id });
            await this.setState({
                ticketId: getTicketData.ticketId,
            });

            this.formRef.current.setFieldsValue({
                ticketType: getTicketData.ticketType,
                chassisNo: getTicketData.chassisNumber,
                comment: getTicketData.comment,
                date: getTicketData?.date
                    ? dayjs(getTicketData.date)
                    : null,
                groupId: getTicketData.groupId,
                location: getTicketData.installedLocation,
                make: getTicketData.make,
                vehicleModel: getTicketData.model,
                plateNumber: getTicketData.plateNumber,
                plateType: getTicketData.plateType,
                plateTypeActivity: getTicketData.plateTypeActivity,
                priority: getTicketData.priority,
                sequenceNo: getTicketData.sequenceNo,
                vehicleId: getTicketData.vehicleId,
                ticketStatus: getTicketData.ticketStatus,
                actionTaken: getTicketData.actionTaken,
                invoice: getTicketData.docs,
                capacity: getTicketData.capacity,
                installationType: getTicketData.installationType ? Number(getTicketData.installationType) : null,
                manufactureYear: getTicketData.manufactureYear
            });

            if (getTicketData.waslIntegration) {
                this.setState({ waslRegistration: true, capacityField: true, })
            }

            if (getTicketData.ticketType == 1) {
                this.setState({ showVehicleDropdown: true, existingIssueRequiredFields: false, hideFields: false })
            }
            if (getTicketData.ticketType == 2) {
                this.setState({ showVehicleDropdown: true, installationTypeDropdown: true, existingIssueRequiredFields: true })
            }
            if (getTicketData.ticketType == 3) {
                this.setState({ showVehicleDropdown: true, existingIssueRequiredFields: true })
            }
            await this.setState({ invoice: getTicketData.docs, loadingSpin: false, ticketStatus: getTicketData.ticketStatus, });

            if (Number(this.props.getUserData().isadmin) == -1 || Number(this.props.getUserData().isadmin) == 3) {
                this.setState({ disabledFields: true })
            }

        }
    }
    async handleSearch() {
        const isadmin = this.props.getUserData().isadmin
        const usercompanyId = this.props.getUserData().userCompanyId
        const addedByUserId = this.props.getUserData().userId
        await this.ticketStore.getTicketData({
            isadmin: isadmin,
            usercompanyId: usercompanyId,
            addedByUserId: addedByUserId,
            offset: 0,
            limit: 50,
        });
        await this.setState({ loadData: 1 });
    }

    onTicketDetailsSubmit = async (values) => {
        this.setState({ loading: true })
        const TicketDetails = {
            ...values,
            ticketId: this.state.ticketId,
            priorityValue: this.state.priorityValue,
            addedByUserId: this.props.getUserData().userId,
            companyId: this.props.getUserData().userCompanyId,
            // date: values?.date
            //     ? values?.date?.format("YYYY-MM-DD")
            //     : null,
            date: dayjs().format("YYYY-MM-DD"),
            addedByDate: dayjs().format("YYYY-MM-DD"),
            waslIntegration: this.state.waslRegistration ? 1 : 0,
            docs: this.state.invoice,
            ticketStatus: this.state.ticketStatus
        };
        const response = await this.ticketStore.addData(TicketDetails);
        this.props.response(response);
        // await this.handleSearch();

        this.setState({ loading: false, loadData: 1 });
    };

    closeModal = () => {
        this.props.closeModal();
    };

    getUploadData = async (fileUp) => {
        let fileinfo = fileUp.file.response;
        if (fileinfo?.success == "S") {
            await this.setState({ invoice: fileinfo.data });
        }
        fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
        this.ticketStore.setPhotoFromDb(fileUp.fileList);
        this.setState({ update: 1 });
    };

    uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("invoice", file);
            formData.append("fileType", "invoice");
            formData.append("fieldName", "invoice");

            const response = await axios.post(
                // config.baseURL + this.companyStore.fileUploadUrl,
                config.NodeUrl + "/ticket/fileUpload",
                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            onError(error);
        }
    };


    render() {
        const isadminCondition = Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ paddingBottom: "10px", height: "100%" }}>
                    <Spin
                        wrapperClassName="spinClass"
                        spinning={this.state.loadingSpin}
                        fullscreen
                    >
                        <Form
                            layout="vertical"
                            onFinish={this.onTicketDetailsSubmit}
                            name="nest-message"
                            ref={this.formRef}
                            className="ticketFormClass"
                            initialValues={{ ticketStatus: 1 }}
                        >

                            <Row className="overflowFormInputs">
                                <Col span={12} className="formColumnClass">
                                    <Form.Item
                                        name="ticketType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_REQUEST_TYPE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_REQUEST_TYPE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: this.context.translate("_TECHNICAL_ISSUE_"), value: 1 },
                                                { label: this.context.translate("_GPS_REMOVAL_"), value: 3 },
                                                { label: this.context.translate("_NEW_INSTALLATION_"), value: 2 },
                                            ]}
                                            onSelect={(val) => {
                                                if (val === 1) {
                                                    this.setState({
                                                        showVehicleDropdown: true,
                                                        hideFields: false,
                                                        existingIssueRequiredFields: false,
                                                        installationTypeDropdown: false,
                                                        capacityField: false,
                                                        waslRegistration: false
                                                    })

                                                } else if (val === 2) {
                                                    this.formRef.current.setFieldsValue({
                                                        plateTypeActivity: undefined,
                                                        capacity: undefined,
                                                    });

                                                    this.setState({
                                                        showVehicleDropdown: true,
                                                        hideFields: true,
                                                        installationTypeDropdown: true,
                                                        existingIssueRequiredFields: true,
                                                        capacityField: false,
                                                    })
                                                } else if (val === 3) {
                                                    this.setState({
                                                        showVehicleDropdown: true,
                                                        hideFields: true,
                                                        installationTypeDropdown: false,
                                                        capacityField: false,
                                                    })
                                                }
                                                else {
                                                    this.formRef.current.setFieldsValue({
                                                        chassisNo: undefined,
                                                        plateNumber: undefined,
                                                        vehicleModel: undefined,
                                                        make: undefined
                                                    });
                                                    this.setState({
                                                        showVehicleDropdown: false,
                                                        hideFields: true,
                                                        existingIssueRequiredFields: true,
                                                        installationTypeDropdown: false,
                                                        capacityField: false,
                                                    })
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {this.state.showVehicleDropdown && <Form.Item
                                        name="vehicleId"
                                        label={
                                            <span>
                                                {this.context.translate("_VEHICLES_")}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}> *</span>
                                                )}
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_VEHICLES_"
                                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            className="select-dropdown"
                                            // mode="multiple"
                                            // maxTagCount={"responsive"}
                                            placeholder={this.context.translate(
                                                "_PLEASE_SELECT_VEHICLES_"
                                            )}
                                            showSearch
                                            onChange={(val, option) => {
                                                const record = option.record;

                                                this.formRef.current.setFieldsValue({
                                                    chassisNo: record.vin || record.chassisNo,
                                                    plateNumber: record.vehicleNo,
                                                    vehicleModel: record.model,
                                                    make: record.vehicleBrand,
                                                    sequenceNo: record.sequenceNo,
                                                    plateTypeActivity: record.plateType,
                                                    manufactureYear: record.manufactureYear
                                                });

                                                this.setState({
                                                    disabledSequenceNo: !!record.sequenceNo,
                                                    disabledPlateType: !!record.plateType,
                                                    capacityField:
                                                        this.formRef.current.getFieldValue("ticketType") === 2 &&
                                                        !!record.plateType,
                                                    disableWaslRegistration: !!(record.sequenceNo || record.plateType),
                                                });
                                            }}

                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                        >
                                            {this.ticketStore?.getVehiclesUsingCompanyId?.map((val) => {
                                                return (
                                                    <Option key={val.vehicleId} record={val} value={val.vehicleId}>{val.vehicleNo}</Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>}

                                    {this.state.installationTypeDropdown && <Form.Item
                                        name="installationType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_INSTALLATION_TYPE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_INSTALLATION_TYPE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: this.context.translate("_ONLY_GPS_"), value: 1 },
                                                { label: this.context.translate("_GPS_WITH_CAN_"), value: 2 },
                                                { label: this.context.translate("_GPS_WITH_MULTIPLE_SENSORS_"), value: 3 },
                                            ]}
                                        />
                                    </Form.Item>
                                    }
                                    <Form.Item
                                        name="chassisNo"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    {/* <Form.Item
                                        name="date"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_DATE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_DATE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <DatePicker style={{ width: "100%", height: "40px" }} />
                                    </Form.Item> */}


                                    <Form.Item
                                        name="make"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_MAKE_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_MAKE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    <Form.Item
                                        name="vehicleModel"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    <Form.Item
                                        name="manufactureYear"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_YEAR_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_YEAR_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>
                                    {/* {this.state.hideFields && <Form.Item
                                        name="groupId"
                                        label={this.context.translate(
                                            "_VEHICLE_GROUPS_"
                                        )}
                                    >
                                        <Select
                                            showSearch
                                            // mode="multiple"
                                            // maxTagCount="responsive"
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                            onChange={async (val) => {

                                                await this.setState({ deviceGroupId: val });

                                            }}

                                        >
                                            {this.workingHoursStore.groupList?.map((val) => {
                                                return (
                                                    <Select.Option
                                                        value={val.deviceGroupId}
                                                        key={val.deviceGroupId}
                                                    >
                                                        {this.props.getUserData().isadmin === 3
                                                            ? val.groupname
                                                            : val.text}
                                                    </Select.Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                    } */}
                                    {!isadminCondition && <Form.Item
                                        name="ticketStatus"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_TICKET_STATUS_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_TICKET_STATUS_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            options={[
                                                { label: this.context.translate("Open"), value: 1 },
                                                { label: this.context.translate("In Progress"), value: 2 },
                                                { label: this.context.translate("On Hold"), value: 3 },
                                                { label: this.context.translate("Resolved"), value: 4 },
                                                { label: this.context.translate("Closed"), value: 5 },
                                            ]}
                                            onSelect={(val) => {
                                                this.setState({ ticketStatus: val })
                                            }}
                                        />
                                    </Form.Item>}

                                    <Form.Item
                                        name="comment"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <TextArea disabled={this.state.disabledFields} />
                                        {/* <Input disabled={this.state.disabledFields} /> */}
                                    </Form.Item>
                                    {(Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3)
                                        && <Form.Item
                                            name=""
                                            label={" "}
                                        >
                                            <Upload
                                                name="invoice"
                                                listType="picture"
                                                onChange={this.getUploadData}
                                                customRequest={(options) =>
                                                    this.uploadFunction(options)
                                                }
                                                disabled={this.state.disabledFields}

                                                maxCount={1}
                                                onRemove={async () => {
                                                    await this.ticketStore.setPhotoFromDb([]);
                                                    await this.setState({ invoice: "", fileList: [] });
                                                }}

                                                {...this.ticketStore.photoFromDb}
                                            >
                                                <Button className="imgupload" icon={<UploadOutlined />}>
                                                    {this.context.translate("_UPLOAD_")}
                                                </Button>
                                            </Upload>
                                        </Form.Item>}


                                </Col>
                                <Col span={12} className="formColumnClass">

                                    <Form.Item
                                        name="plateNumber"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_NUMBER_"
                                                )}{" "}
                                                {this.state.existingIssueRequiredFields && (
                                                    <span style={{ color: "red" }}>*</span>
                                                )}

                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: this.state.existingIssueRequiredFields,
                                                message: `${this.context.translate(
                                                    "_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    <Form.Item
                                        name="priority"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_PRIORITY_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_PRIORITY_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: this.context.translate("Low"), value: 1 },
                                                { label: this.context.translate("Medium"), value: 2 },
                                                { label: this.context.translate("High"), value: 3 },

                                            ]}
                                            onSelect={(val) => {
                                                this.setState({ priorityValue: val })
                                            }}
                                        />
                                    </Form.Item>

                                    {!this.state.waslRegistration && <Form.Item
                                        name="plateType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_PLATE_TYPE_"
                                                )}{" "}
                                            </span>
                                        }
                                    >
                                        <Select
                                            disabled={this.state.disabledFields}
                                            options={[
                                                { label: "Private Vehicle", value: "private" },
                                                { label: "Public Vehicle", value: "public" },
                                            ]}

                                        />
                                    </Form.Item>}

                                    <Form.Item
                                        name="location"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_VEHICLE_AVAILIBILITY_LOCATION_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_LOCATION_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input disabled={this.state.disabledFields} />
                                    </Form.Item>

                                    {this.state.hideFields && <Form.Item
                                        name=""
                                        label={" "}
                                    >
                                        <Checkbox
                                            disabled={this.state.disabledFields || this.state.disableWaslRegistration}

                                            style={{ marginTop: "10px", marginBottom: "7px" }}
                                            checked={this.state.waslRegistration}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    waslRegistration: e.target.checked,
                                                    capacityField: false,
                                                    plateTypeActivity: null
                                                });
                                                this.formRef.current?.setFieldsValue({
                                                    plateTypeActivity: undefined,
                                                });
                                            }}
                                        />&nbsp;{this.context.translate("_REQUIRE_WASL_INTEGRATION_")}
                                    </Form.Item>}
                                    {this.state.waslRegistration &&
                                        <>
                                            <Form.Item
                                                name="sequenceNo"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Input disabled={this.state.disabledFields || this.state.disabledSequenceNo} />
                                            </Form.Item>

                                            <Form.Item
                                                name="plateTypeActivity"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    disabled={this.state.disabledFields ||
                                                        this.state.disabledPlateType}
                                                    style={{ width: "100%" }}
                                                    placeholder={this.context.translate("_SELECT_TYPE_")}
                                                    onChange={(value) => {
                                                        const ticketType = this.formRef.current.getFieldValue("ticketType");

                                                        this.setState({
                                                            capacityField: ticketType === 2 && !!value,
                                                        });


                                                        if (!value) {
                                                            this.formRef.current.setFieldsValue({
                                                                capacity: undefined,
                                                            });
                                                        }
                                                    }}
                                                    allowClear
                                                >
                                                    <Select.Option value="DEFAULT">
                                                        {" "}
                                                        {this.context.translate("_DEFAULT_TYPE_")}
                                                    </Select.Option>
                                                    <Select.Option value="TOW_CAR">
                                                        {this.context.translate("_TOW_CAR_1_")}
                                                    </Select.Option>
                                                    <Select.Option value="SPECIALITY_TRANSPORT">
                                                        {this.context.translate("_SPECIALITY_TRANSPORT_1_")}
                                                    </Select.Option>

                                                    <Select.Option value="EDUCATIONAL_TRANSPORT">
                                                        {this.context.translate("_EDUCATIONAL_TRANSPORT_1_")}
                                                    </Select.Option>
                                                    <Select.Option value="BUS_RENTAL">
                                                        {this.context.translate("_BUS_RENTAL_1_")}
                                                    </Select.Option>
                                                </Select>
                                            </Form.Item>

                                            {this.state.capacityField && <Form.Item name="capacity"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_CAPACITY_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_CAPACITY_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                    {
                                                        pattern: /^\d+$/,
                                                        message: "Capacity must contain only numbers",
                                                    },
                                                ]}>
                                                <Input disabled={this.state.disabledFields} />
                                            </Form.Item>}
                                        </>
                                    }

                                    {this.state.waslRegistration && (
                                        <Form.Item
                                            name="plateType"
                                            label={
                                                <span>
                                                    {this.context.translate("_PLATE_TYPE_")}
                                                </span>
                                            }
                                        >
                                            <Select
                                                disabled={this.state.disabledFields}
                                                options={[
                                                    { label: "Private Vehicle", value: "private" },
                                                    { label: "Public Vehicle", value: "public" },
                                                ]}
                                            />
                                        </Form.Item>
                                    )}

                                    {!isadminCondition && <Form.Item
                                        name="actionTaken"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_ACTION_TAKEN_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_ACTION_TAKEN_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>}

                                </Col>
                            </Row>

                            <div className="formFooter">
                                <Button
                                    className="formsCancelButton"
                                    onClick={() => this.closeModal()}
                                >
                                    {this.context.translate(
                                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                    )}
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="formsSaveButton"
                                    loading={this.state.loading}
                                // onClick={() => this.onExcelSubmit()}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

TicketAdd.contextType = StoreContext;
export default observer(withRouter(TicketAdd));
